import { BlockSource } from "@/lib/interfaces and Enums/ENUMBlockSource";

// LQC-3241 - these customers change their FIX orders only through their own FIX
// Replace, so the app blocks its edits. Front end only: the API still accepts them.
export const FIX_EDIT_LOCKED_CUSTOMERS: string[] = ["ARD-UK", "ARD-AU", "LDC"];

export function isFixEditLockedCustomer(
  customerCode: string | null | undefined,
): boolean {
  return FIX_EDIT_LOCKED_CUSTOMERS.includes(customerCode ?? "");
}

// A fill on a FIX block (LQC-3241) whose customer is locked.
export function isFixEditLocked(
  source: string | null | undefined,
  customerCodes: (string | null | undefined)[],
): boolean {
  if (source !== BlockSource.FIX) return false;
  return customerCodes.some(isFixEditLockedCustomer);
}
